import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import { researchData } from "../constants/data/researchData";
import { useNavigate } from "react-router";

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  height: 200,
  [theme.breakpoints.down("sm")]: {
    width: "100% !important", // Overrides inline-style
    // height: 100,
  },
  "&:hover, &.Mui-focusVisible": {
    zIndex: 1,
    "& .MuiImageBackdrop-root": {
      opacity: 0.15,
    },
    "& .MuiImageMarked-root": {
      opacity: 0,
    },
    "& .MuiTypography-root": {
      border: "4px solid currentColor",
    },
  },
  border: '2px solid #1976d2',

}));

const ImageSrc = styled("span")({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: "cover",
  backgroundPosition: "center 40%",
  
});

const Image = styled("span")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.common.white,
  
}));

const ImageBackdrop = styled("span")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.black,
  opacity: 0.4,
  transition: theme.transitions.create("opacity"),
}));

const ImageMarked = styled("span")(({ theme }) => ({
  height: 3,
  width: 18,
  backgroundColor: theme.palette.common.white,
  position: "absolute",
  bottom: -2,
  left: "calc(50% - 9px)",
  transition: theme.transitions.create("opacity"),
}));

export default function RelatedResearchButtons({ researchIds }) {
  const navigate = useNavigate();
  
  const relatedResearch = researchIds.map((id, index) =>
    researchData.find((item) => item.id === id)
  );

  const navigateToPage = (id) => {
    const researchDetailData = researchData.find((dict) => dict.id === id);

    console.log(researchDetailData);
    navigate(`/research/${researchDetailData.title.toLowerCase().replace(/\s/g, "-")}-${researchDetailData.id}`); 
  }

  return (
    <Box
      sx={{ display: "flex", flexWrap: "wrap", minWidth: 250, width: "100%" , justifyContent: "center", alignItems: "center",}}
    >
      {relatedResearch.map((research, index) => (
        <ImageButton
          focusRipple
          key={index}
          style={{
            width: "35%",
            margin: '2px',
          }}
          onClick={() => navigateToPage(research.id)}
        >
          <ImageSrc
            style={{
              backgroundImage: `url(${require(`../assets/images/${research.image}`)})`,
            }}
          />
          <ImageBackdrop className="MuiImageBackdrop-root" />
          <Image>
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              sx={(theme) => ({
                position: "relative",
                p: 4,
                pt: 2,
                pb: `calc(${theme.spacing(1)} + 6px)`,
              })}
            >
              {research.title}
              <ImageMarked className="MuiImageMarked-root" />
            </Typography>
          </Image>
        </ImageButton>
      ))}
    </Box>
  );
}
